/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Meteorology16Inputs */

const en__field_enum_study_meteorology16 = /** @type {(inputs: _Field_Enum_Study_Meteorology16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meteorology`)
};

const de__field_enum_study_meteorology16 = /** @type {(inputs: _Field_Enum_Study_Meteorology16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meteorologie`)
};

/**
* | output |
* | --- |
* | "Meteorology" |
*
* @param {_Field_Enum_Study_Meteorology16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_meteorology16 = /** @type {((inputs?: _Field_Enum_Study_Meteorology16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Meteorology16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_meteorology16(inputs)
	return de__field_enum_study_meteorology16(inputs)
});
export { _field_enum_study_meteorology16 as "_field_enum_STUDY_METEOROLOGY" }